module.exports = __webpack_public_path__ + "img/pr-6.032cf791.png";